export const environment = {
  production: false,
  root_uri: "https://beta.kingtrivia.com",
  host: "betahost.kingtrivia.com",
  api_domain: "beta.kingtrivia.com",
  ws: { protocol: "wss" }
};
